import UserManager from './services/UserManager'
import { getUrlParam } from './utils/UrlUtils'
import { storePromoCode } from './services/promoCodeStore'
import { saveMaterialType } from './utils/materialTypeUtils'
import { setSelectedColor, setSelectedSize } from './hooks/tileStyling/utils'
import { OtefProjectViewStore } from './services/otefProjectViewStore'
import { experimentManager } from './services/ExperimentManager/ExperimentManager'

import { type TILES_SOURCE } from './components/TilesProvider/TilesProvider.consts'
import { type UserContextValue } from 'services/UserProvider'
import { klaviyo } from './services/Analytics/platforms/klaviyo'
import { startSessionReplay } from './services/Analytics/platforms/amplitude'
import { ART_COLLECTION_ENTRYPOINT_URL } from './config/config'
import { initArtCatalog } from './services/artCatalogService'
import { getStoreState } from './stores/store'
import { URL_PARAM_KEYS } from 'pages/PhotoStyler/tileCustomization.consts'

export async function initEntrypoint(
  user: UserContextValue,
  tilesSource: TILES_SOURCE
) {
  const appLink = getUrlParam('app_link')

  if (appLink) {
    const url = new URL(window.location.href)
    window.location.href = `mixtiles://${url.search}`
  }

  const { isExistingUser } = user
  UserManager.initializeUserProperties()
  klaviyo.setUserProperties(experimentManager.getUserProperties())

  const promoCode = getUrlParam('promo')
  if (promoCode) {
    if (experimentManager.isEnabled('checkout-v2')) {
      getStoreState().setAppliedPromoCodeFromBanner(promoCode)
    } else {
      storePromoCode(promoCode)
    }
  }

  const otefProjectViewParam = getUrlParam('withlove')
  if (otefProjectViewParam) {
    OtefProjectViewStore.set(otefProjectViewParam === 'true')
  }

  saveMaterialType(getUrlParam(URL_PARAM_KEYS.MATERIAL), tilesSource)
  setSelectedSize(getUrlParam(URL_PARAM_KEYS.SIZE), tilesSource)
  setSelectedColor(getUrlParam(URL_PARAM_KEYS.FRAME_COLOR), tilesSource)
  UserManager.updateLastVisitDate()
  startSessionReplay()
  if (window.location.pathname.startsWith(ART_COLLECTION_ENTRYPOINT_URL)) {
    await initArtCatalog()
  }
  return {
    user: { ...user, isExistingUser },
  }
}
